module.exports = __webpack_public_path__ + "static/media/larynx_ai2.65f87baa.png";